import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyA6NdBcFmI3vW31Vdjyjmfe3Bv23OD1r2o",
    authDomain: "redditcl.firebaseapp.com",
    projectId: "redditcl",
    storageBucket: "redditcl.appspot.com",
    messagingSenderId: "1097835089526",
    appId: "1:1097835089526:web:010007d93a75172f61d957"
  };

  const app = firebase.initializeApp(firebaseConfig);

  const auth = firebase.auth();
  
  const db = app.firestore();
  
  const googleProvider = new firebase.auth.GoogleAuthProvider();
  
  export { auth, googleProvider };
  
  export default db;
  